<template>
  <div class="view pa24">
    <div class="d-flex align-items-center">
      <div class="mr20 mb10">
        {{ $t('finance', 'name') }}：
        <el-input class="w220" v-model="nickeName" :placeholder="$t('finance', 'userName')" />
      </div>
      <div class="mr20 mb10">
        {{ $t('finance', 'phoneNumber') }}：
        <el-input class="w220" v-model="phone" :placeholder="$t('finance', 'phoneNumber')" />
      </div>
      <div class="mr20 mb10">
        {{ $t('finance', 'withdrawalTime') }}：
        <el-date-picker
          v-model="pickerValue"
          value-format="yyyy-MM-dd"
          align="right"
          type="daterange"
          :start-placeholder="$t('finance', 'startDate')"
          :end-placeholder="$t('finance', 'endDate')"
          :picker-options="pickerOptions"
        />
      </div>
    </div>
    <div>
      {{ $t('finance', 'orderStatus') }}：
      <el-radio
        class="mr10"
        style="margin-left: 0"
        v-for="(item, index) in radioArr"
        :key="'status-' + index"
        v-model="radio1"
        :label="index"
        border
        >{{ item }}</el-radio
      >
      {{ $t('finance', 'userCategory') }}：
      <el-radio
        class="mr10"
        style="margin-left: 0"
        v-for="(item, index) in roleArr"
        :key="'role-' + index"
        v-model="radio2"
        :label="index"
        border
        >{{ item }}</el-radio
      >
      <el-button type="primary" @click="getTableData">{{ $t('finance', 'search') }}</el-button>
    </div>
    <commonTable :tableData="tableData"
                  :loading="loading"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrentChange="handleCurrentChange"
                  :currentPage="currentPage"
                  :total="total">
      <template v-slot:table>
        <el-table-column prop="avatar" align="center" :label="$t('finance', 'avatar')">
          <template slot-scope="scope">
            <el-image style="width: 36px;height:36px" :src="scope.row.logo ? scope.row.logo : scope.row.avatarUrl">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="name" align="center" :label="$t('finance', 'name')">
          <template slot-scope="scope">
            <div  >{{scope.row.name ? scope.row.name : scope.row.nickeName}}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="phone"  :label="$t('finance', 'contactInfo')" >
          <template slot-scope="scope">
            <div  >{{scope.row.bcPhone ? scope.row.bcPhone : scope.row.phone}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          align="center"
          :label="$t('finance', 'withdrawalAmount')"
        />
        <el-table-column
          prop="createdTime"
          align="center"
          :label="$t('finance', 'applicationTime')"
        />
        <el-table-column align="center" prop="userType"  :label="$t('finance', 'userCategory')">
          <template slot-scope="scope">
            <div >{{scope.row.userType == 1 ? $t('finance', 'employee') : $t('finance', 'normal')}}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="approvalStatus"  :label="$t('finance', 'status')">
          <template slot-scope="scope">
            <!--审核状态 0等待打款  打款成功1 已驳回2-->
            <div >{{scope.row.approvalStatus == 0 ? $t('finance', 'waitingForPayment') : scope.row.approvalStatus == 1 ? $t('finance', 'paymentSuccessful') : scope.row.approvalStatus == 2 ? $t('finance', 'rejected') : ""}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="approvalTime" align="center" :label="$t('finance', 'approvalTime')" />
        <el-table-column align="center" fixed="right" :label="$t('finance', 'operation')"  width="170">
          <template slot-scope="scope">
            <el-button v-if="scope.row.approvalStatus == 0" type="text" @click="makeMoney(scope.row,1)" size="small">
              {{ $t('finance', 'confirm') }}
            </el-button>
            <el-button v-if="scope.row.approvalStatus == 0" type="text" @click="makeMoney(scope.row,2)" size="small">
              {{ $t('finance', 'reject') }}
            </el-button>
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import { queryWithdrawals,makeMoney } from "@/api/financing";
import i18nMixin from "@/mixins/i18nMixin";

export default {
  name: "withdrawalList",
  mixins: [i18nMixin],
  components: {
    commonTable,
  },
  data() {
    return {
      pickerValue: "", //选择时间
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      radioArr: [this.$t('finance', 'all'), this.$t('finance', 'waitingForPayment'), this.$t('finance', 'paymentSuccessful'), this.$t('finance', 'rejected')],
      roleArr: [this.$t('finance', 'all'), this.$t('finance', 'employee'), this.$t('finance', 'normal')],
      radio1: 0,
      radio2:'',
      tableData: [],
      pageSize:10,
      pageNum:1,
      phone:'',
      total: 0,
      loading:false,
      currentPage:0,
      nickeName:''
    };
  },
  created(){
    this.getTableData()
  },
  methods:{
    //请求表格数据
    getTableData() {
      this.loading = true;
      let data = {
        pageSize : this.pageSize,
        pageNum : this.pageNum,
        createdTime:this.pickerValue,
        startTime:this.pickerValue ? this.pickerValue[0]:'',
        endTime:this.pickerValue ? this.pickerValue[1]:'',
        phone:this.phone,
        approvalStatus:this.radio1-1 == '-1' ? '' : this.radio1 -1,
        nickeName : this.nickeName,
        userType:this.radio2 == 0 ? '' : this.radio2
       };
      queryWithdrawals(data)
      .then((res) => {
        let arr = []
        this.loading = false;
        this.tableData = res.data.pageInfo.list;
        this.total = res.data.pageInfo.total;
      })
             .catch((err) => {
         this.loading = false;
         this.tableData = [];
         this.total = 0;
       });
    },
    //打款
    makeMoney(row,approvalStatus){
      this.$confirm(this.$t('finance', 'confirmTip') + (approvalStatus == 1 ? this.$t('finance', 'confirm') : this.$t('finance', 'reject')) + '吗？', this.$t('finance', 'tips'), {
        confirmButtonText: this.$t('finance', 'confirm'),
        cancelButtonText: this.$t('finance', 'cancel'),
        type: "info ",
      })
      .then(() => {
        row.approvalStatus = approvalStatus;
        makeMoney(row)
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: "success",
              message: this.$t('finance', 'operationSuccess'),
            });
            this.getTableData()
          }
        })
      })
      .catch((err) => {});
      
      
    },
    //当前页变更
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getTableData();
    },
    //当前页查询数据条数变更
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.currentPage = 1;
      this.getTableData();
    },
    detail(id){
      this.$router.push({ path:`/personalCommissionDetall?id=${id}` });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>